const entityWrap = (data, Entity) => {
  return new Entity(data)
}

const entityCollectionWrap = (data, Entity) => {
  return data.map(d => entityWrap(d, Entity))
}

export {
  entityWrap,
  entityCollectionWrap
}



// WEBPACK FOOTER //
// ./src/utils/index.js